import axios from 'axios';
import { ProjectConfig } from 'Global';

/*=========================================================
API REQUEST
=========================================================*/
export const ApiRequest = async (params: any) => {
    
    //if localStorage.setItem('ltkn', response.ltkn); exists send as header
    const ltkn = localStorage.getItem('ltkn');
    
    if (ltkn) {
        params.headers = {
            ...params.headers,
            'ltkn': ltkn
        }
    }
    
    const store_id = localStorage.getItem('store_id');
    if (store_id) {
        params.headers = {
            ...params.headers,
            'store_id': store_id
        }
    }

    const {
        url, 
        method, 
        headers, 
        body = null,
        query = null,
        formData = false,
        setResponse,
        onError = null,
        onFinally = null,
    } = params;

    // If formData is true, ensure we use FormData and set the correct header
    let data: any = null;
    if (formData && body instanceof FormData) {
        data = body;
        params.headers = {
            ...params.headers,
            'Content-Type': 'multipart/form-data'
        };
    } else {
        data = body ? body : null;
    }

    const request_params = {
        url: ProjectConfig.api_url + url,
        method: method,
        headers: {
            ...headers
        },
        params: {
            ...query
        },
        data
    };

    /*REQUEST
    =========================================================*/
    await axios.request(request_params)
        .then((response) => {
            console.log(`${url} response`, response.data);
            setResponse(response.data);
        })
        .catch((err) => {
            console.log("error", err);
            if (onError && typeof onError === 'function') {
                // Extract error message from response if available
                const errorMessage = err.response?.data?.message || err.message || 'An error occurred';
                onError({
                    message: errorMessage,
                    status: err.response?.status,
                    details: err.response?.data,
                    error: err
                });
            }
        })
        .finally(() => {
            // Execute onFinally callback if provided
            if (onFinally && typeof onFinally === 'function') {
                onFinally();
            }
        });
};

/*=========================================================
PRICE FORMATTING
=========================================================*/
export const formatCanadianPrice = (price: string | number): string => {
    const numPrice = typeof price === 'string' ? parseFloat(price) || 0 : price || 0;
    return numPrice.toLocaleString('en-CA', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};



